import { isNodeEdge, NodeEdge } from "@hex-insights/app-modules";

// TODO hex core update replace with version from App Modules

/**
 * Returns the node from the given node or edge.
 *
 * @param e The node or edge.
 */
export function asNode<T>(e: T | NodeEdge<T>): T {
	return isNodeEdge(e) ? e.node : e;
}
